/**
 * Formats a file size in bytes to a human-readable string.
 *
 * Uses binary units (1 MB = 1,048,576 bytes) to match how file systems
 * and upload validators measure size.
 *
 * @param bytes - File size in bytes (must be a positive integer)
 * @returns Formatted string like "10MB", "512KB", "1.5GB"
 */
export function formatFileSize(bytes: number): string {
  if (bytes <= 0) return '0B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const base = 1024;

  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(base)),
    units.length - 1,
  );

  const value = bytes / Math.pow(base, exponent);

  // Use integer display when the value is whole, otherwise 1 decimal place
  const formatted = value % 1 === 0 ? value.toString() : value.toFixed(1);

  return `${formatted}${units[exponent]}`;
}
